import { Dtos, type UserId } from "@inrev/common";
import { type EntityScope, scopeMatches } from "../../../shared/scope";

type BondRequestPreview = Pick<
	Dtos.SuretyQuote.Preview.Get.Response,
	"status" | "underwriterUserId"
>;

export type BondRequestMetricsInput = {
	bondRequestPreviews: BondRequestPreview[];
	scope: EntityScope;
	currentUserId: UserId;
};

export type BondRequestMetrics = {
	totalOpen: number;
	inReview: number;
	approved: number;
	accepted: number;
	pending: number;
};

export const computeBondRequestMetrics = ({
	bondRequestPreviews,
	scope,
	currentUserId,
}: BondRequestMetricsInput): BondRequestMetrics => {
	const scopedRequests = bondRequestPreviews.filter((request) =>
		scopeMatches(scope, request.underwriterUserId, currentUserId),
	);

	const inReview = scopedRequests.filter((request) => request.status === "review").length;
	const approved = scopedRequests.filter((request) => request.status === "approved").length;
	const accepted = scopedRequests.filter((request) => request.status === "accepted").length;
	const pending = scopedRequests.filter((request) => request.status === "pending").length;

	return {
		totalOpen: inReview + approved + accepted + pending,
		inReview,
		approved,
		accepted,
		pending,
	};
};
